import { Injectable, InjectionToken } from '@angular/core';
import { CustomSearchResults, OccSearchBoxSuggestions, OccSuggestionItem } from '@search/const';
import { Converter } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class SuggestionsSolrNormalizer implements Converter<OccSearchBoxSuggestions, CustomSearchResults> {
  convert(source: OccSearchBoxSuggestions, target: CustomSearchResults): CustomSearchResults {
    if (!target) {
      target = { ...source } as any;
    }

    try {
      target.sts = source.suggestions.map(({ value }: OccSuggestionItem) => ({ st: value }));
    } catch {}

    return target;
  }
}

export const SUGGESTIONS_SOLR_NORMALIZER = new InjectionToken<SuggestionsSolrNormalizer>(
  'SuggestionsAnyQueryNormalizer',
);
